// generated from 15 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const receivedFeatureFlagVariantFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("received_feature_flag_variant_filter"),
  comparison_key: z.enum(["7", "8"]),
  display_name: z.object({
    data: z.array(
      z.object({
        id: common.objectId,
        name: z.string(),
      })
    ),
    expired: z.literal(false),
    id: common.objectId,
    value: z.string(),
  }),
  // Only present when the filters_include_raw_values feature flipper is on (FilterJsonFormatter#filter_as_json).
  raw_value: common.objectId.optional(),
  value: z.object({
    id: common.objectId,
    name: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
